export const navigate = (url: string) => window.navigation.navigate(url);
export const navigateReplace = (url: string) =>
  window.navigation.navigate(url, { history: "replace" });
export const reload = () => window.navigation.reload();
